<div class="doc-list">
  <!-- Upload (edit mode only) -->
  <div class="upload-row" *ngIf="isEditMode">
    <button nz-button nzType="default" (click)="fileInput.click()">
      <i nz-icon nzType="upload" nzTheme="outline"></i>
      {{ "Upload files" | translate }}
    </button>
    <input
      #fileInput
      type="file"
      (change)="onFileSelected($event)"
      accept=".pdf,image/*"
      multiple
      hidden
    />
  </div>

  <!-- Files of this document category -->
  <ng-container *ngIf="document?.filePaths?.length; else emptyState">
    <div
      class="doc-row"
      *ngFor="let f of document!.filePaths; trackBy: trackByFile"
    >
      <div class="left">
        <i
          nz-icon
          nzType="file-pdf"
          nzTheme="outline"
          *ngIf="isPdf(f.path)"
        ></i>
        <i
          nz-icon
          nzType="file-image"
          nzTheme="outline"
          *ngIf="isImage(f.path)"
        ></i>
        <i
          nz-icon
          nzType="file"
          nzTheme="outline"
          *ngIf="!isPdf(f.path) && !isImage(f.path)"
        ></i>

        <div class="meta">
          <div class="name" [title]="fileName(f.path)">
            {{ fileName(f.path) }}
          </div>
        </div>
      </div>

      <div class="actions">
        <!-- VIEW: opens modal preview (no download) -->
        <button
          nz-button
          nzType="default"
          nzShape="round"
          class="action-btn"
          (click)="viewDocument(f)"
          [disabled]="!canPreview(f.path)"
        >
          <i nz-icon nzType="eye" nzTheme="outline"></i>
          <span class="btn-text">
            {{ "View" | translate }}
          </span>
        </button>

        <!-- DOWNLOAD: download only -->
        <button
          nz-button
          nzType="default"
          nzShape="round"
          class="action-btn"
          (click)="downloadDocument(f.path, f.id.toString())"
        >
          <i nz-icon nzType="download" nzTheme="outline"></i>
          <span class="btn-text">
            {{ "Download" | translate }}
          </span>
        </button>

        <!-- DELETE: only in edit mode -->
        <button
          *ngIf="isEditMode"
          nz-button
          nzType="primary"
          nzDanger
          nzShape="round"
          class="action-btn btn-danger-solid"
          (click)="deleteDocument(f.id.toString())"
        >
          <i nz-icon nzType="delete" nzTheme="outline"></i>
          <span class="btn-text">
            {{ "Delete" | translate }}
          </span>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-template #emptyState>
    <div class="empty">
      <i nz-icon nzType="inbox" nzTheme="outline"></i>
      <span>{{ "No files uploaded yet" | translate }}</span>
    </div>
  </ng-template>
</div>
